import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { Category, InfoItem } from '../data-printer/data-printer.component';

export interface CategoryV2 extends Category {
    labelWidth?: string;
    maxWidth?: string;
}

@Component({
  selector: 'app-data-printer-v2',
  templateUrl: './data-printer-v2.component.html',
  styleUrls: ['./data-printer-v2.component.scss']
})
export class DataPrinterV2Component implements OnInit {

    @Input()
    categories: CategoryV2[];

    constructor(
        private utilsService: UtilsService
    ) { }

    ngOnInit() {
    }

    parseByType(item: InfoItem) {
        return this.utilsService.parseByType(item.value, item.type);
    }

}
